import * as particles from 'pixi-particles'
import { signal } from 'services/SignalsService'
import { config } from 'settings/custom/particles'

export default class ParticleSignals extends PIXI.ParticleContainer {
  constructor(data) {
    super()
    this._data = data
    this.createParticle()
  }

  get data() {
    return this._data
  }

  createParticle() {
    const data = this.data

    let elements = data.particle.split(',')
    elements.forEach((element) => {
      let settings = Object.assign({}, config[element])
      if(config[element].spawnType === 'rect'){
        settings.spawnRect.x = data.x ? data.x : 0
        settings.spawnRect.y = data.y ? data.y : 0
        settings.spawnRect.w = data.width
        settings.lifetime.max = data.lifetime

      }
      else if (config[element].spawnType === 'circle'){
        settings.pos.x = data.offsetX ? data.offsetX : 0
        settings.pos.y = data.offsetY ? data.offsetY : 0
        settings.spawnCircle.r = data.r ? data.r : 0
      }

      settings.isAnimate = data.isAnimate
      let emitter = new particles.Emitter(
        this,
        settings.isAnimate ? [
          {
            framerate: data.frameRate || 20,
            loop: true,
            textures: this.particleArr(data.count, data.particleName),
          },
        ] : this.particleArr(data.count, data.particleName),
        settings,
      )
      if(settings.isAnimate){
        emitter.particleConstructor = particles.AnimatedParticle
      }

      emitter.emit = false

      this.createSignals(emitter, data, element)
    })
  }

  particleArr(count, name) {
    let arr = []
    for (let i = 1; i < count + 1; i++) {
      arr.push(game.getTextureFromAtlases(name + i))
    }
    return arr
  }

  addParticleSignals(emitter, data, element) {
    emitter.emit = !!data.init

    if (data.signalOff && data.signalOn) {
      const onSignalOff = () => {
        emitter.emit = false
        emitter.startSpeed.next.value = data.fadeSpeed
      }
      const onSignalOn = () => {
        emitter.emit = true
        emitter.startSpeed.next.value = config[element].speed.end
      }

      data.signalOff.split(',').forEach((eventName) => {
        signal.on(`${eventName}`, onSignalOff)
      })
      signal.on(`${data.signalOff}`, onSignalOff)

      data.signalOn.split(',').forEach((eventName) => {
        signal.on(`${eventName}`, onSignalOn)
      })
      signal.on(`${data.signalOn}`, onSignalOn)
    }
  }

  createSignals(emitter, data, element) {
    if (!config.resize) {
      emitter.emit = true
      this.addParticleSignals(emitter, data, element)
    }
    else {
      signal.on('RESIZE', ({ orientation }) => {
        emitter.emit = data.name == orientation
      })
    }
  }

}
